export default function alfaLeiloesSwiperCards() {
  const swiperLotes = new Swiper(".cards-wrapper", {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 16,
      // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: true,
    breakpoints: {
      540: {
        slidesPerView: 2.2,
        slidesPerGroup: 2,
        spaceBetween: 16,
      },

      768: {
        slidesPerView: 2.5,
        slidesPerGroup: 2,
        spaceBetween: 16,
      },

      1024: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 30,
      },
    },
    navigation: {
      // nextEl: ".swiper-button-next",
      // prevEl: ".swiper-button-prev",
      nextEl: ".custom-arrow-next",
      prevEl: ".custom-arrow-prev",
    },
  });
}
